<template>
  <DefaultLayout>
    <Suspense>
      <RouterView :key="$route.fullPath" />
    </Suspense>
  </DefaultLayout>
</template>

<script setup lang="ts">
import DefaultLayout from '@/layouts/DefaultLayout.vue';
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Lato:wght@400;700&display=swap');

html {
  font-size: 16px;
  line-height: 24px;
  font-family: 'Lato', Arial, sans-serif;

  body {
    margin: 0;
  }
}

.bold {
  font-weight: bold;
}

.v-toolbar__content {
  overflow: unset !important;
}
</style>
